import { render, staticRenderFns } from "./ContactTable.vue?vue&type=template&id=5470f7d4&scoped=true&"
import script from "./ContactTable.vue?vue&type=script&lang=js&"
export * from "./ContactTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactTable.vue?vue&type=style&index=0&id=5470f7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470f7d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VCheckbox,VContainer,VFlex,VIcon,VImg,VLayout,VProgressCircular})
